module.exports = __webpack_public_path__ + "media/images/logo3-4e46004ac5280df32f7bafb99d7fffbf.png";